<!-- Dialog que da muestra las dos diferentes opciones para crear una cuenta de organizador (Organizador WeChamber o LITE)-->
<template>
  <v-card>
    <v-card-text>
      <v-container>
        <v-row justify="space-between">
          <v-col cols="12" class="pb-0 ma-0">
            <p class="font-weight-bold text-left pa-0 ma-0 primary--text title-user-type"> {{($vuetify.breakpoint.xsOnly)?'Bienvenido a WeChamber!':'Bienvenido a WeChamber!'}}</p>
            <p
              class="caption text-left pa-0 ma-0"
            >Comencemos eligiendo el tipo de cuenta que se ajuste a tus necesidades</p>
            <br />
          </v-col>
          <!--<v-col cols="2" class="pb-0 ma-0">
            <v-img src="@/assets/logo-WC-solo.png" width="45px" max-height="auto"></v-img>
          </v-col>-->
        </v-row>
        <v-row>
          <v-col cols="12" md="6" class="black--text pb-0">
            <!--<p class="accent--text title"><strong>Registrarme como organizador WeChamber</strong></p>-->
            <v-btn
              color="amber"
              to="/registro/organizacion"
              class="mb-3"
              block
              :large="$vuetify.breakpoint.smAndDown"
              :x-large="$vuetify.breakpoint.mdAndUp"

            ><strong>Organizador WeChamber</strong></v-btn>
            
            <v-row class="mb-3">
              <v-col cols="1" class="mr-5 py-0">
                <v-icon left color="primary" x-large>mdi-laptop-chromebook</v-icon>
              </v-col>
              <v-col cols="9" sm="10" class="py-0">
                <p class="text-justify my-0 amber--text"><strong>PUBLICAR</strong></p>
                <p class="text-justify my-0 caption">Subir mis cursos y eventos gratuitos y/o con costo.</p>
              </v-col>
            </v-row>
            <v-row class="mb-3">
              <v-col cols="1" class="mr-5 py-0">
                <v-icon left color="primary" x-large>mdi-calendar-clock</v-icon>
              </v-col>
              <v-col cols="9" sm="10" class="py-0">
                <p class="text-justify my-0 amber--text"><strong>CALENDARIO</strong></p>
                <p class="text-justify my-0 caption">Personalizar mi calendario (mi sección propia).</p>
              </v-col>
            </v-row>
            <v-row class="mb-3">
              <v-col cols="1" class="mr-5 py-0">
                <v-icon left color="primary" x-large>mdi-format-float-left</v-icon>
              </v-col>
              <v-col cols="9" sm="10" class="py-0">
                <p class="text-justify my-0 amber--text"><strong>FORMULARIO PERSONALIZADO</strong></p>
                <p class="text-justify my-0 caption">Crear mis formularios de registro con todos los campos que necesite.</p>
              </v-col>
            </v-row>
            <v-row class="mb-3">
              <v-col cols="1" class="mr-5 py-0">
                <v-icon left color="primary" x-large>mdi-cash-multiple</v-icon>
              </v-col>
              <v-col cols="9" sm="10" class="py-0">
                <p class="text-justify my-0 amber--text"><strong>PAGOS EN LÍNEA</strong></p>
                <p class="text-justify my-0 caption">
                  Recibir pagos con tarjeta de crédito, débito, transferencia y Oxxo Pay.
                </p>
              </v-col>
            </v-row>
            <v-row class="mb-3">
              <v-col cols="1" class="mr-5 py-0">
                <v-icon left color="primary" x-large>mdi-view-quilt</v-icon>
              </v-col>
              <v-col cols="9" sm="10" class="py-0">
                <p class="text-justify my-0 amber--text"><strong>MI TABLERO</strong></p>
                <p
                  class="text-justify my-0 caption"
                >Habilitar mi tablero, generar bases de datos y estadísticas de asistencias, ventas, facturas y más.</p>
              </v-col>
            </v-row>
            <v-row class="mb-3">
              <v-col cols="1" class="mr-5 py-0">
                <v-icon left color="primary" x-large>mdi-dots-horizontal</v-icon>
              </v-col>
              <v-col cols="9" sm="10" class="py-0">
                <p class="text-justify my-0 amber--text"><strong>Y MUCHO MÁS</strong></p>
                <p class="text-justify my-0 caption">WeChamber tiene toda la tecnología que necesitas para vender y administrar tu oferta de capacitación.</p>
              </v-col>
            </v-row>
            <br />
          </v-col>
          <v-col cols="12" md="6" class="black--text pb-0">
            <!--<p class="secondary--text title"><strong>Registrarme con WeChamber Lite (Nueva versión "Ligera")</strong></p>-->
            <v-btn
              color="secondary"
              to="/registro-organizador-lite"
              class="mb-3"
              block
              dark
              :large="$vuetify.breakpoint.smAndDown"
              :x-large="$vuetify.breakpoint.mdAndUp"
            ><strong>Organizador Lite</strong></v-btn>
            <p>Nueva versión “ligera” de WeChamber</p>
            <v-row class="mb-3">
              <v-col cols="1" class="mr-5 py-0">
                <v-icon left color="primary" x-large>mdi-laptop-chromebook</v-icon>
              </v-col>
              <v-col cols="9" sm="10" class="py-0">
                <p class="text-justify my-0 secondary--text"><strong>PUBLICAR</strong></p>
                <p
                  class="text-justify my-0 caption"
                >Puedo subir los flyers de mis cursos y webinars. Al click enlaza a cualquier página de registro.</p>
              </v-col>
            </v-row>
            <v-row class="mb-3">
              <v-col cols="1" class="mr-5 py-0">
                <v-icon left color="primary" x-large>mdi-calendar-clock</v-icon>
              </v-col>
              <v-col cols="9" sm="10" class="py-0">
                <p class="text-justify my-0 secondary--text"><strong>MI CALENDARIO</strong></p>
                <p
                  class="text-justify my-0 caption"
                >Personalizar mi calendario con todos mis cursos y webinars.</p>
              </v-col>
            </v-row>
            <!--<li>Estoy a un botón de distancia de hacer UPGRADE y comenzar a cobrar en línea y usar todas las funciones de WeChamber si así lo deseo.</li>-->
            <br />
          </v-col>
        </v-row>
        <!--
        <v-row justify="center" class="d-flex justify-space-between mt-5">
          <v-btn color="amber" to="/registro/organizacion" class="mb-3" :block="($vuetify.breakpoint.xsOnly)?true:false">Organizador WeChamber</v-btn>
          <v-btn color="secondary" to="/registro-organizador-lite" class="mb-3" :block="($vuetify.breakpoint.xsOnly)?true:false">Organizador Lite</v-btn>
        </v-row>-->
      </v-container>
    </v-card-text>
  </v-card>
</template>
<script>
export default {
  methods: {
    redirectPrices() {
      this.$router.push("/precios-y-comisiones");
    }
  }
};
</script>
<style scoped>
@media (max-width: 599px) {
  .title-user-type {
    font-size: 2.12rem!important;
    line-height: 2.12rem;
    letter-spacing: -.0063333333em!important;
  }
}
@media (min-width: 600px) {
  .title-user-type {
    font-size: 3.12rem!important;
    line-height: 3.12rem;
    letter-spacing: -.0073333333em!important;
  }
}
</style>